var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 33,
    viewBox: "0 0 134 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.809 22.7535H123.386V24.2977H128.489V22.7535H130.067V19.7322H133.189V22.7535H131.645V24.2977H130.067V25.8419H121.809V24.2977H120.231V22.7535H118.586V10.769H120.231V9.25833H121.809V7.71411H130.067V9.25833H131.645V10.769H133.189V16.5766H121.809V22.7535ZM121.809 14.9652H130.067V10.8026H128.489V9.25833H123.386V10.8026H121.809V14.9652Z",
    fill: "#1A1918",
    stroke: "#1A1918",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4326 12.3803H99.9768V10.8697H101.454V9.32547H103.166V7.71411H113.539V28.7961H112.028V30.3403H110.518V31.8845H101.991V30.3403H100.413V28.7961H98.7683V26.7147H101.991V28.7961H103.569V30.3403H108.94V28.7961H110.518V22.0485H108.94V23.6599H101.588V22.0485H100.01V20.4707H98.4326V12.3803ZM101.588 20.4371H103.132V22.0485H107.396V20.4371H108.94V18.8258H110.518V9.32547H104.777V10.8697H103.166V12.4139H101.588V20.4371Z",
    fill: "#1A1918",
    stroke: "#1A1918",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8525 22.6528V19.0272H81.4639V17.4158H83.0753V15.8045H91.5685V10.8026H89.9907V9.25833H85.9623V10.8026H84.3845V13.7903H81.2625V10.769H82.8067V9.25833H84.3845V7.71411H91.5685V9.25833H93.1463V10.769H94.7241V25.8419H93.0791V24.2306H91.5685V25.8419H83.176V24.2306H81.4639V22.6192L79.8525 22.6528ZM83.1424 22.6192H84.7202V24.2306H90.0578V22.6192H91.5685V17.4158H84.7202V19.0608H83.1424V22.6192Z",
    fill: "#1A1918",
    stroke: "#1A1918",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0586 4.05487H76.67V12.1452H74.8572V13.6895H72.9773V15.2337H64.3498V25.8418H61.0264V2.54422H62.7049V1H73.313V2.54422H75.0586V4.05487ZM64.3498 13.6895H71.3659V12.1452H73.313V4.08844H71.7016V2.54422H64.3498V13.6895Z",
    fill: "#1A1918",
    stroke: "#1A1918",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1533 7.71411H32.2418V20.2357H33.786V21.8471H37.7808V20.2357H39.325V18.6244H40.9028V7.71411H43.9241V28.7961H42.4135V30.3403H40.9028V31.8845H32.7117V30.3403H31.134V28.7961H29.489V26.7147H32.7117V28.7961H34.2895V30.3403H39.325V28.7961H40.9028V21.8471H39.325V23.4584H32.3089V21.8471H30.7311V20.2693H29.1533V7.71411Z",
    fill: "#1A1918",
    stroke: "#1A1918",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25.8418V1H6.47191V4.32343H8.18398V7.34473H9.89605V10.366H11.4738V13.3873H13.2531V10.366H14.8644V7.34473H16.4758V4.32343H18.0871V1H22.4512V2.6785H24.1297V25.8418H20.8063V4.32343H19.1278V7.34473H17.55V10.366H15.9722V13.3873H14.3944V16.4086H13.2531V19.4299H10.2989V16.4086H9.15751V13.3873H7.57972V10.366H6.00193V7.34473H4.42414V4.32343H2.74564V25.8418H1Z",
    fill: "#1A1918",
    stroke: "#1A1918",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPage);
export default __webpack_public_path__ + "static/media/MyPage.749589253aaafcad4971b97ee59c93c2.svg";
export { ForwardRef as ReactComponent };